import React, { useState, useEffect, Fragment } from "react";

import {
  Form,
  Input,
  Button,
  Popconfirm,
  message,
  Table,
  Tag,
  Dropdown,
  Space,
  Menu,
  Select,
} from "antd";

import {
  DeleteFilled,
  PlusCircleFilled,
  DownOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./SiteList.module.less";

const { Option } = Select;

function SiteList({ navigate, location }) {
  const { state } = location;

  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState({});
  const [search, setSearch] = useState(state?.search ? state?.search : {});
  const [pagination, setPagination] = useState(
    state?.pagination
      ? state?.pagination
      : {
        current: 1,
        pageSize: 10,
        total: 0,
      }
  );

  const [form] = Form.useForm();

  const columns = [
    {
      title: "编号",
      dataIndex: "id",
      key: "id",
      width: 100,
      fixed: "left",
    },
    {
      title: "站点名称",
      dataIndex: "name",
      key: "name",
      width: 120,
      fixed: "left",
      ellipsis: true,
    },
    {
      title: "站点域名",
      dataIndex: "host",
      key: "host",
      width: 160,
      fixed: "left",
      ellipsis: true,
      render: (value, data) => (
        <a href={data.url} title={value} target="_blank">
          {value}
        </a>
      ),
    },
    {
      title: "顶部LOGO",
      dataIndex: "logoTopUrl",
      key: "logoTopUrl",
      width: 200,
      render: (value) => (
        <img
          style={{ maxWidth: 120, maxHeight: 24, display: "block" }}
          src={value}
          alt=""
        />
      ),
    },
    {
      title: "底部LOGO",
      dataIndex: "logoEndUrl",
      key: "logoEndUrl",
      width: 200,
      render: (value) => (
        <img
          style={{ maxWidth: 120, maxHeight: 24, display: "block" }}
          src={value}
          alt=""
        />
      ),
    },
    {
      title: "站点ICO",
      dataIndex: "faviconUrl",
      key: "faviconUrl",
      width: 100,
      render: (value) => (
        <img
          style={{ maxWidth: 120, maxHeight: 24, display: "block" }}
          src={value}
          alt=""
        />
      ),
    },
    {
      title: "模式",
      dataIndex: "genSubDomain",
      key: "genSubDomain",
      width: 100,
      ellipsis: true,
      render: (value) => {
        if (value === 0) return <Tag color="purple">主站</Tag>;
        if (value === 1) return <Tag color="blue">子站</Tag>;
        return false;
      },
    },
    {
      title: "关键词",
      dataIndex: "keyword",
      key: "keyword",
      width: 160,
      ellipsis: true,
    },
    {
      title: "简介",
      dataIndex: "description",
      key: "description",
      width: 160,
      ellipsis: true,
    },
    {
      title: "新闻规则",
      dataIndex: "genBrandNewsShow",
      key: "genBrandNewsShow",
      width: 160,
      ellipsis: true,
    },
    {
      title: "产品规则",
      dataIndex: "genBrandProductShow",
      key: "genBrandProductShow",
      width: 160,
      ellipsis: true,
    },
    {
      title: "品牌规则",
      dataIndex: "genBrandPageHome",
      key: "genBrandPageHome",
      width: 160,
      ellipsis: true,
    },
    {
      title: "模板",
      dataIndex: "skin",
      key: "skin",
      width: 120,
      render: (value) => <Tag color="cyan">{value.replace("s", "")}号模板</Tag>,
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      width: 100,
      render: (value) => {
        return value === 1 ? (
          <Tag color="green">开启</Tag>
        ) : (
            <Tag color="red">关闭</Tag>
          );
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 160,
      fixed: "right",
      render: (_, data) => (
        <Fragment>
          <Button
            type="link"
            size="small"
            onClick={() => {
              navigate(`save`, { state: { data, search, pagination } });
            }}
          >
            编辑
          </Button>
          <Dropdown overlay={actionMenu(data)}>
            <Button type="link" size="small">
              操作
              <DownOutlined />
            </Button>
          </Dropdown>
        </Fragment>
      ),
    },
  ];

  const actionMenu = (value) => {
    return (
      <Menu>
        <Menu.Item>
          <div
            onClick={() =>
              onSwitch({
                ...value,
                status: value.status === 0 ? 1 : 0,
              })
            }
          >
            {value.status === 0 ? (
              <Space>
                <CheckOutlined />
                <span>开启</span>
              </Space>
            ) : (
                <Space>
                  <CloseOutlined />
                  <span>关闭</span>
                </Space>
              )}
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <Space onClick={() => onDelete(value.id)}>
            <DeleteOutlined />
            <span>删除</span>
          </Space>
        </Menu.Item>
      </Menu>
    );
  };

  const onSwitch = async (values) => {
    let para = queryString.stringify({ values });
    try {
      let parsed = await Http.post(`site/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onSearch = (values) => {
    if (values.kw) {
      values.kw = values.kw.replace(/\s+/g, "");
    }
    setSearch(values);
    onLoading({
      search: values,
      pagination: { current: 1, pageSize: 10, total: 0 },
    });
  };

  const onDelete = async (id) => {
    let para = queryString.stringify({ id });
    try {
      let parsed = await Http.post(`site/delete`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
        setSelected([]);
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const getSiteList = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`site`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setData(parsed.result);
      setPagination({
        current: parsed.result.pageNumber,
        pageSize: parsed.result.pageSize,
        total: parsed.result.totalRow,
      });
    }
  };

  const onLoading = async (params) => {
    setLoading(true);
    try {
      await getSiteList({
        ...params.search,
        pageNumber: params.pagination.current,
        pageSize: params.pagination.pageSize,
      });
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onLoading({ search, pagination });
  }, []);

  return (
    <div className={styles.SiteList}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {selected.length > 0 ? (
            <Space>
              <Popconfirm
                title="是否确认删除?"
                onConfirm={() => {
                  onDelete(selected);
                }}
              >
                <Button type="primary" danger icon={<DeleteFilled />}>
                  删除
                </Button>
              </Popconfirm>
            </Space>
          ) : (
              <Button
                type="primary"
                icon={<PlusCircleFilled />}
                onClick={() => navigate(`save`)}
              >
                新增
              </Button>
            )}
        </div>
        <div className={styles.headerRight}>
          <Form
            initialValues={search}
            form={form}
            layout="inline"
            onFinish={onSearch}
          >
            <Form.Item name="kw" style={{ width: 240 }}>
              <Input placeholder="请输入关键词" />
            </Form.Item>
            <Form.Item name="status">
              <Select
                placeholder="请选择状态"
                style={{ width: 120 }}
                allowClear
              >
                <Option value="0">关闭</Option>
                <Option value="1">开启</Option>
              </Select>
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="reset"
                onClick={() => {
                  form.resetFields();
                }}
              >
                重置
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className={styles.content}>
        <Table
          loading={loading}
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            onChange: (srk) => {
              setSelected(srk);
            },
          }}
          onChange={(p, f, s) => {
            let sort = null;
            if (s.order) {
              sort = `${s.field} ${s.order.replace("end", "")}`;
            }
            onLoading({ search: { ...search, sort }, pagination: p });
          }}
          dataSource={data.list}
          columns={columns}
          pagination={pagination}
          scroll={{ x: 1660 }}
        />
      </div>
    </div>
  );
}
export default SiteList;
